<template>
    <ModalBase v-show="show" :with-content="true" @close="close">
        <section class="fd-r fw-w m-jc-sb">
            <div class="flexContainer fd-c ai-c jc-fs">
                <div class="flexContainer fd-c">
                    <h1>{{ $t("plano.enter_new_name") }}</h1>
                    <input class="full planoName mt10" v-model="selectedPlano.name" :placeholder="$t('plano.name_placeholder')" />
                    <p class="danger" v-if="nullName">{{ $t("duplicatePlano.enterName") }}</p>
                </div>
                <footer>
                    <ClientColorButton :disabled="!planoNameIsCorrect" @click="savePlanoNewName();">
                        {{ $t("plano.btn_validate") }}
                    </ClientColorButton>
                </footer>
            </div>
        </section>
    </ModalBase>
</template>
<script>
import httpService from "@/components/service";
import { mapGetters } from "vuex";
import ModalBase from "@/components/modal/ModalBase";
import ClientColorButton from "@/components/ui/ClientColorButton";
import { isValidNameLength } from "@/utils/string";

export default {
    data() {
        return {
            nullName: null,
            selectedPlano: {
                name: undefined,
                id: undefined
            }
        };
    },
    components: {
        ModalBase,
        ClientColorButton
    },
    watch: {
        currentPlanoName: function() {
            this.selectedPlano.name = this.currentPlanoName;
        },
        currentPlanoId: function() {
            this.selectedPlano.id = this.currentPlanoId;
        }
    },
    props: {
        show: {},
        currentPlanoId: {},
        currentPlanoName: {}
    },
    methods: {
        savePlanoNewName() {
            this.nullName = false;
            if (!this.planoNameIsCorrect) {
                this.nullName = true;
                return true;
            }
            let saveNamePlano = {
                name: this.selectedPlano.name.trim()
            };
            httpService.post("/plano/" + this.selectedPlano.id, JSON.stringify(saveNamePlano)).then(response => {
                location.reload();
            });
        },
        close() {
            this.$emit("close", false);

            this.$store.dispatch("planos/search/getResults", {}).then(() => {
                this.planos = this.getResults();
                this.$emit("searchResults", this.getResults());
            });
            this.nullName = false;
        }
    },
    mounted() {
        document.addEventListener("keydown", e => {
            if (this.show && e.keyCode === 27) {
                this.close();
            }
        });
    },
    computed: {
        ...mapGetters({
            getResults: "planos/search/getResults"
        }),
        planoNameIsCorrect() {
            return isValidNameLength(this.selectedPlano.name);
        }
    },
    created() {
        let params = {};
        this.$store.dispatch("planos/search/getResults", params).then(() => {
            this.planos = this.getResults();
        });
    }
};
</script>

<style lang="scss" scoped>
.planoName {
    padding: 0.5em;
    font-size: 1.2em;
    border: none;
    border-bottom: 2px solid #333;
    width: 300px;
}
.danger {
    font-size: 1.2rem;
}
footer {
    margin: 10px 0px;
}
</style>



// WEBPACK FOOTER //
// editName.vue?073204d2